import {Action} from '@ngrx/store';

export const GET_ALL_POTENTIALS = '[Potentials] Get All';
export const GET_ALL_POTENTIALS_SUCCESS = '[Potentials] Get All Success';
export const GET_ALL_POTENTIALS_ERROR = '[Potentials] Get All Error';

export const GET_POTENTIAL = '[Potentials] Get Potential';
export const GET_POTENTIAL_SUCCESS = '[Potentials] Get Potential Success';
export const GET_POTENTIAL_ERROR = '[Potentials] Get Potential Error';

export const APPROVE_POTENTIAL = '[Potential] Approve';
export const REJECT_POTENTIAL = '[Potential] Reject';
export const UPDATE_POTENTIAL_SUCCESS = '[Potential] Update Success';
export const UPDATE_POTENTIAL_ERROR = '[Potential] Update Error';


export class GetAllPotentials implements Action {
  readonly type = GET_ALL_POTENTIALS;
}

export class GetAllPotentialsSuccess implements Action {
  readonly type = GET_ALL_POTENTIALS_SUCCESS;

  constructor(public payload: any) {
  }
}

export class GetAllPotentialsError implements Action {
  readonly type = GET_ALL_POTENTIALS_ERROR;

  constructor(public payload: any) {
  }
}

export class GetPotential implements Action {
  readonly type = GET_POTENTIAL;

  constructor(public payload: any) {
  }
}

export class GetPotentialSuccess implements Action {
  readonly type = GET_POTENTIAL_SUCCESS;

  constructor(public payload: any) {
  }
}

export class GetPotentialError implements Action {
  readonly type = GET_POTENTIAL_ERROR;

  constructor(public payload: any) {
  }
}

export class ApprovePotential implements Action {
  readonly type = APPROVE_POTENTIAL;

  constructor(public payload: any) {
  }
}

export class RejectPotential implements Action {
  readonly type = REJECT_POTENTIAL;

  constructor(public payload: any) {
  }
}

export class UpdatePotentialSuccess implements Action {
  readonly type = UPDATE_POTENTIAL_SUCCESS;

  constructor(public payload: any) {
  }
}

export class UpdatePotentialError implements Action {
  readonly type = UPDATE_POTENTIAL_ERROR;

  constructor(public payload: any) {
  }
}

export type PotentialAction =
  GetAllPotentials
  | GetAllPotentialsSuccess
  | GetAllPotentialsError
  | GetPotential
  | GetPotentialError
  | GetPotentialSuccess
  | ApprovePotential
  | RejectPotential
  | UpdatePotentialSuccess
  | UpdatePotentialError;



// WEBPACK FOOTER //
// /Users/Chetan/Downloads/angular5_admin-master/src/app/potentials/store/actions/potential.action.ts